import React, { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useFormikContext } from 'formik'
import { _ } from 'utils'
import ConfirmModal from 'components/ConfirmModal'
import { UpdateEventInput } from 'generated/graphql'
import { addModal } from 'features/modals/modalSlice'
import ActivationStatus from '../components/ActivationStatus'
import SettingFormContent from '../components/SettingFormContent'

const Setting = () => {
    const dispatch = useDispatch()
    const formContext = useFormikContext()
    const values = formContext.values as UpdateEventInput & {
      paid: boolean,
      firstPublishedAt: string,
      isActivationRequested: boolean
      organization: {
          subdomain: string
      }
      hasPublishedNetworking?: boolean
    }
    const { touched: touchedOpenedField } = formContext.getFieldMeta('published')
    const setFieldValue = formContext.setFieldValue
    const setFieldTouched = formContext.setFieldTouched
    const published = values.published

    const showConfirmModal = useCallback(() => {
        const handleCancel = () => {
            // Reset touched state of field after canceling
            setFieldTouched('published', false)
            setFieldValue('published', !published)
        }
        dispatch(addModal({
            Component: ({ close }: { close: () => void }) => (
                <ConfirmModal
                    close={close}
                    title={
                        published
                            ? _('generalsettings.form.published_title_modal')
                            : _('generalsettings.form.unpublished_title_modal')
                    }
                    confirmDescription={
                        published
                            ? (values.hasPublishedNetworking
                                ? _('generalsettings.form.publish_event_with_networking_open_confirm')
                                : _('generalsettings.form.published_description_modal')
                            ) : _('generalsettings.form.unpublished_description_modal')
                    }
                    onCancel={handleCancel}
                    variantConfirm="primary"
                />
            ),
            shouldNotWrap: true
        }))
    // Don't want setFieldTouched and setFieldValue in deps. Because they are changed after submitting
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, published])

    const shouldShowConfirmModal = !formContext.isSubmitting && touchedOpenedField && !formContext.submitCount
    useEffect(() => {
        // Show the confirm modal when un/publish the event
        if (shouldShowConfirmModal) {
            showConfirmModal()
        }
    }, [shouldShowConfirmModal, showConfirmModal])

    return (
        <>
            <ActivationStatus />
            <SettingFormContent values={values} />
        </>
    )
}

export default Setting
